import TimeOnTaskReport from '../../../../components/TimeOnTaskReport';
import { useReportContext } from '../../components/reportContext';

const LoginActivityTTReport = () => {
  const {assignmentId,  includeRetakes,  selectedClassId,  selectedStudentId,  studentName , selectedCourseId,  startDate, 
    endDate, className} = useReportContext();

  return (
    <>  
      <div id="reportWrapper">
        <TimeOnTaskReport 
          assignmentId={assignmentId}
          includeRetakes={includeRetakes}
          isFromTeacherReport={true}
          classId={selectedClassId}
          className={className}
          courseId={selectedCourseId}
          studentId={selectedStudentId}
          studentName={studentName}
          startDate={startDate}
          endDate={endDate}
          studentToInclude={2}
          backButtonOnClick={()=>window.history.back()}
          isLoginActivityReport={true} />
      </div>
    </>
  );
};

export default LoginActivityTTReport;